import type { ModuleSettings } from "../../apis/user.apis";
import type { iOnboardingFlags } from "../../types/internal";

export function isThemeEmbedPromptDismissed(
  profileSetting?: iOnboardingFlags | null,
  embedStatus?: ModuleSettings | null,
): boolean {
  return (
    profileSetting?.theme_embed_setup_complete === true
    || profileSetting?.theme_embed_setup_acknowledged === true
    || embedStatus?.theme_embed_setup_complete === true
    || embedStatus?.theme_embed_setup_acknowledged === true
  );
}
